import Vue from 'vue';
import App from './App';
import RouterConfig from './router';
import StoreConfig from './store';
import Fundation from 'fundation-app-vuejs';
import {Router, Store, I18n} from 'fundation-app-vuejs';
import metaDefinition from './store/meta';
import EventBus from './eventBus.js';

Vue.prototype.$eventBus = EventBus;

Vue.use(Fundation);

StoreConfig.metaDefinition = metaDefinition;
StoreConfig.apiRootUrl = window.config.api_root_url;

Vue.config.productionTip = false;
Vue.directive('click-outside',{
    bind: function (el, binding, vnode) {
        el.eventOnClick = function (event) {
            // Check that the click was outside the el and its children, and wasn't a drag
            if (!(el === event.target || el.contains(event.target))) {
                // call method provided in attribute value
                vnode.context[binding.expression](event);
            }
        };
        document.addEventListener('click', el.eventOnClick);
    }, unbind: function (el) {
        document.removeEventListener('click', el.eventOnClick);
    },
});
/* eslint-disable no-new */
let app = new Vue({
    el: '#app',
    router: new Router(RouterConfig),
    store: new Store(StoreConfig),
    components: { App },
    template: '<App/>',
    i18n: new I18n(),
});
function translation(key, context){ return app.$t(key, context);}

app.$store.commit('fundation/SET_TRANSLATION_METHOD', translation);

app.$store.dispatch('fundation/changeLang', {lang: 'en', i18n: app.$i18n});
// pour supprimer le loader 1 une fois fundation chargé
let loading1 = document.querySelector('#loading1');
loading1.parentNode.removeChild(loading1);

window.app = app;



// WEBPACK FOOTER //
// ./src/main.js